module.exports = __webpack_public_path__ + "static/media/uday.bd87da2f.png";